import axiosInstance from "./axiosInstance";

const agentReportsService = {
  getSummary: async (params = {}) => {
    const res = await axiosInstance.get("/admin/agent-reports/summary", { params });
    return res.data;
  },

  logActivity: async (payload) => {
    const res = await axiosInstance.post("/admin/agent-reports/activity", payload);
    return res.data;
  },

  listActivities: async (params = {}) => {
    const res = await axiosInstance.get("/admin/agent-reports/activity", { params });
    return res.data;
  },

  exportMonthlyRevenue: async (params = {}) => {
    const res = await axiosInstance.get("/admin/agent-reports/export/monthly-revenue", {
      params,
      responseType: "blob",
    });
    return res.data;
  },

  syncIntegrations: async (payload) => {
    const res = await axiosInstance.post("/admin/agent-reports/integrations/sync", payload);
    return res.data;
  },
};

export default agentReportsService;
